import { Gym, IBasicAuthenticationUser, ZENDESK_TICKET_FIELDS } from 'fitbeat.models';
import getLogger from '../util/logging';

const logger = getLogger('zendesk');

function setZendeskPrefill(key: string, value: string, readOnly = true) {
  try {
    const zendesk = (window as any).zE;
    if (!zendesk) {
      logger.warn('zendesk is not available');
      return;
    }
    logger.trace(`set ${key}=${value}`);
    zendesk('messenger:set', 'conversationFields', [{ id: key, value }]);;
  } catch (error) {
    logger.error(error, `zendesk messenger error setting ${key}=${value}`);
  }
}

export function updateZendeskWidget(gym: Gym) {
  setZendeskPrefill(ZENDESK_TICKET_FIELDS.GYM_EMAIL, gym.email || '');
  setZendeskPrefill(ZENDESK_TICKET_FIELDS.GYM_NAME, gym.name || '');
  setZendeskPrefill(ZENDESK_TICKET_FIELDS.ORGANISATION, gym.organisation || '');
  setZendeskPrefill(ZENDESK_TICKET_FIELDS.GYM_TIMEZONE, gym.timezone || '');
}

export function setupZendeskWidget(user: IBasicAuthenticationUser, selectedGym: Gym) {
  setZendeskPrefill(ZENDESK_TICKET_FIELDS.BT_USERNAME, user.name);
  updateZendeskWidget(selectedGym);
}
